
define('text!modules/trainings/states/trainings/template.html',[],function () { return '<header class=row><div class=column><help key=TRAININGS.HEADER.HELP class=u-right></help><h1 translate=TRAININGS.HEADER.TITLE></h1></div></header><trainings-list></trainings-list>';});

